import { IconStar, mapper } from '@maia/icons';
import { InsuranceDto } from '@maia/shared';
import { FeaturedIcon, Typography } from '../../../ui';
import { BaseCardProps, CardBase } from './base';

interface InsuranceCardProps extends BaseCardProps {
  readonly insurance: InsuranceDto;
}

export function InsuranceCard(props: InsuranceCardProps) {
  const { insurance, ...rest } = props;
  return (
    <CardBase {...rest}>
      <Typography
        variant="body-xs"
        weight="medium"
        className="text-primaryMain"
      >
        {insurance.reference}
      </Typography>
      <div className="flex items-center gap-x-14 flex-grow">
        <FeaturedIcon icon={mapper(insurance.icon)} variant="light-circle" />
        <div className="flex flex-col">
          <Typography
            variant="body-xs"
            weight="medium"
            className="text-primaryMain"
          >
            {insurance.title}
          </Typography>
          <Typography
            variant="body-xs"
            weight="regular"
            className="text-grayscale300"
          >
            {insurance.customer.consumer.fullName}
          </Typography>
        </div>
        {insurance.isSpecialLimit && (
          <FeaturedIcon
            icon={<IconStar />}
            variant="light-circle"
            color="warning"
            size="xs"
            className="ml-auto"
          />
        )}
      </div>
    </CardBase>
  );
}
